import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableContainer,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { read, utils } from "xlsx";
import { send } from "../../SendRequest";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    main: {
        flex: 1,
        padding: "2.5%",
        width: "80%",
    },
    button: {
        textTransform: "initial",
    },
    upload: {
        display: "none",
    },
    title: {
        fontWeight: "bold",
        fontSize: "15pt",
    },
    label: {
        paddingTop: "5pm",
        paddingBottom: "5px",
        // color: "grey",
    },
    table: {
        borderSpacing: "0px",
        border: "1px solid #ddd",
    },
    td: {
        borderSpacing: "0px",
        border: "1px solid #ddd",
        padding: "2px",
    },
    xlstable: {
        width: "100%",
        maxHeight: "500px",
        overflow: "auto",
        marginTop: "10px",
    },
    btnsave: {
        marginTop: "10px",
    },
    error: {
        color: "red",
        marginTop: "10px",
    },
});

function CCCUpdatePage() {
    const [xlsData, setXlsData] = useState(null);
    const { t, i18n } = useTranslation();
    const styles = useStyles();
    const dispatch = useDispatch();

    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };

    const [isDataIncorrect, setIsDataIncorrect] = useState(false);
    const handleDataIncorrectClose = () => {
        setIsDataIncorrect(false);
    };

    const [isSomethingWrong, setIsSomethingWrong] = useState(false);
    const handleSomethingWrong = () => {
        setIsSomethingWrong(false);
    };

    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleSavedClose}>
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function FailToSaveDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("errorMsg.mappingError.saveFailed")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("errorMsg.mappingError.errReason")}
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleDataIncorrectClose}>
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function SomethingWrongDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("errorMsg.unknownError")}
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleSomethingWrong}>
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    const excelKey = [
        "KG Chinese name",
        "KG English name",
        "School no.",
        "Location no.",
        "CCC English name",
        "CCC Chinese name",
        "Post of Responsible Officer",
        "English name of Responsible Officer",
        "Chinese name of Responsible Officer",
        "Email of Responsible Officer",
        "Telephone no. of Responsible Officer",
        "CCC English address",
        "CCC Chinese address",
    ];
    const dbKey = [
        "kgChiName",
        "kgEngName",
        "schNo",
        "locNo",
        "cccEngName",
        "cccChiName",
        "officerPost",
        "officerEngName",
        "officerChiName",
        "officerEmail",
        "officerTel",
        "cccEngAddress",
        "cccChiAddress",
    ];

    const readUploadFile = (e) => {
        e.preventDefault();
        if (e.target && e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = utils.sheet_to_json(worksheet);
                updateJSON(json);
            };
            reader.readAsArrayBuffer(e.target.files[0]);
        }
    };

    const renameKey = (obj, oldKey, newKey) => {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    };

    const updateJSON = (json) => {
        if (json) {
            for (let i = json.length - 1; i > -1; i--) {
                if (json[i]) {
                    let obj = json[i];
                    if (
                        obj["School no."] === "" ||
                        (!obj["KG Chinese name"] && !obj["KG English name"]) ||
                        (!obj["CCC English name"] && !obj["CCC Chinese name"])
                    ) {
                        json.splice(i, 1);
                    } else {
                        for (let x = 0; x < excelKey.length; x++) {
                            renameKey(obj, excelKey[x], dbKey[x]);
                        }
                    }
                }
            }
        }
        setXlsData(json);
    };

    const sendXls = (e) => {
        const option = {
            url: `${Config.CONTENT_PATH}/clo/setKGCCC`,
            method: "POST",
            body: JSON.stringify(xlsData),
        };
        dispatch(send("SUBMIT_CCC_DATA", option))
            .then((response) => response.json())
            .then((result) => {
                if (result && result.status != null) {
                    switch (result.status) {
                        case 0:
                            console.log("Save Success");
                            setIsSavedOpen(true);
                            break;
                        case 1:
                            console.log("Save Failed");
                            if (result.msg)
                                console.log("Fail Msg:", result.msg);
                            setIsDataIncorrect(true);
                            break;
                        default:
                            console.log("Something went wrong");
                            if (result.msg)
                                console.log("Fail Msg:", result.msg);
                            setIsSomethingWrong(true);
                            break;
                    }
                }
            })
            .catch((error) => console.log("fetch error", error));
    };

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.parameterPage")}
                className="header"
            />
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main className={styles.main}>
                    <form>
                        <Box>
                            <Typography variant="h6" component="h1">
                                {t("CCCUpdatePage.updateCCCInfo")}
                            </Typography>
                            <Typography className={styles.label}>
                                {t("CCCUpdatePage.uploadExcelFile")}
                            </Typography>
                            <Button variant="outlined" component="label">
                                {t("common.fileUploadMsg")}
                                <input
                                    hidden
                                    accept=".xls,.xlsx"
                                    multiple
                                    type="file"
                                    onChange={readUploadFile}
                                />
                            </Button>
                        </Box>
                    </form>
                    {xlsData && xlsData.length > 0 && (
                        <TableContainer componant={Paper}>
                            <Box className={styles.xlstable}>
                                <Table className={styles.table}>
                                    <thead>
                                        {
                                            <tr>
                                                {excelKey.map((header) => (
                                                    <th
                                                        className={styles.td}
                                                        key={header}
                                                    >
                                                        {header}
                                                    </th>
                                                ))}
                                            </tr>
                                        }
                                    </thead>
                                    <tbody>
                                        {xlsData.map((data, x) => (
                                            <tr key={x}>
                                                {dbKey.map((dbKeyData, y) => (
                                                    <td
                                                        className={styles.td}
                                                        key={
                                                            dbKeyData +
                                                            "_" +
                                                            x +
                                                            "_" +
                                                            y
                                                        }
                                                    >
                                                        {data[dbKeyData]}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Box>
                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                className={styles.btnsave}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={sendXls}
                                >
                                    {t("common.portal.saveBlock")}
                                </Button>
                            </Box>
                        </TableContainer>
                    )}
                    {xlsData && xlsData.length === 0 && (
                        <Box className={styles.error}>
                            {t("CCCUpdatePage.wrongFileFormat")}
                        </Box>
                    )}
                    {isSavedOpen ? SavedDialog(isSavedOpen) : null}
                    {isDataIncorrect ? FailToSaveDialog(isDataIncorrect) : null}
                    {isSomethingWrong
                        ? SomethingWrongDialog(isSomethingWrong)
                        : null}
                </main>
            </Box>
        </Container>
    );
}
export default CCCUpdatePage;
